import React from 'react';
import withAnimation from '../../../hooks/withAnimation';
import { routeNames } from '../../../routes/routeNames';
import { useNavigate } from 'react-router-dom';

const description = "At your initial appointment, your Kinesiologists will perform a thorough evaluation, which will determine if Kinesio taping will be an effective option for your treatment plan. If so, your Kinesiologists will explain how it will benefit your journey toward recovery and the step-by-step process that you will go through to get there. Kinesio taping works by doing a few important things for your body. It helps in resetting the circuitry in the affected part of your body by correcting any faulty interactions between the skin and muscles, joints, and tendons underneath. This results in improved muscle strength and activity. Kinesio taping at South Coast Physiotherapy in West Brantford, Simcoe, Paris, East Brantford, Tillsonburg, Delhi and Hamilton, ON also works by blocking any pain receptors being sent to your brain.";


const WhatDoesSection = ({ title = "Physiotherapy", imageUrl,mainDescription = description }) => {
    const navigate = useNavigate()
  return (
    <section className="relative bg-gradient-to-r from-primary to-primarylight text-white py-12 lg:py-16 overflow-hidden">
      <div className="container mx-auto px-4 lg:px-16 flex flex-col-reverse lg:flex-row items-center justify-between space-y-8 lg:space-y-0 space-x-0 lg:space-x-12">
        <div className="lg:w-1/2">
          <h2 className="text-4xl sm:text-5xl font-extrabold mb-6 tracking-wider text-start lg:text-left">
            What does <span className="text-secondary">{title}</span> do?
          </h2>
          <p className="text-justify  sm:text-lg lg:text-lg mb-8 leading-relaxed max-w-xl lg:text-justify">
            {mainDescription}
          </p>
          <div className="flex justify-center lg:justify-start">
            <a onClick={()=>navigate(routeNames.contact)} className="bg-secondary text-white text-base sm:text-lg py-3 px-6 rounded-full shadow-lg hover:bg-white hover:text-secondary transition duration-300 ease-in-out">
              Book an Appointment
            </a>
          </div>
        </div>
        <div className="lg:w-1/2 relative flex justify-center">
          <div className="absolute w-40 h-40 bg-white opacity-10 rounded-full -left-10 -top-10 hidden lg:block"></div>
          <div className="absolute w-32 h-32 bg-white opacity-10 rounded-full -right-10 -bottom-10 hidden lg:block"></div>
          <img src={imageUrl} alt={title} className="relative z-10 rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-500 ease-in-out w-3/4 lg:w-full" />
        </div>
      </div>
    </section>
  );
};

export default withAnimation(WhatDoesSection);
